import Vue from 'vue'
import VueRouter from 'vue-router'
import ContentPage from '../views/ContentPage.vue'
import { pages, blogs, blogIndex, canonical, getSchema } from '@/documents/siteContent.js'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}

function pageRoute(key) {
	const page = pages[key]
	return {
		path: page.slug,
		name: `id-${key}`,
		meta: {
			appname: 'WA GB',
			contentKey: key,
			title: page.seoTitle,
			keywords: page.keywords,
			description: page.description,
			schema: getSchema(page),
			link: [
				{
					rel: 'canonical',
					href: canonical(page.slug)
				}
			]
		},
		component: ContentPage
	}
}

function blogRoute(blog) {
	return {
		path: blog.slug,
		name: `id-${blog.key}`,
		meta: {
			appname: 'WA GB',
			contentKey: blog.key,
			title: blog.seoTitle,
			keywords: blog.keywords,
			description: blog.description,
			schema: getSchema(blog),
			link: [
				{
					rel: 'canonical',
					href: canonical(blog.slug)
				}
			]
		},
		component: ContentPage
	}
}

export const constRoutesPc = [
	pageRoute('home'),
	{
		path: '/download',
		redirect: '/download-wa-gb/'
	},
	{
		path: '/blogs',
		redirect: '/blog/'
	},
	{
		path: '/privacy',
		redirect: '/privacy-policy/'
	},
	pageRoute('download'),
	pageRoute('update'),
	pageRoute('ban'),
	pageRoute('iphone'),
	pageRoute('pc'),
	pageRoute('login'),
	pageRoute('oldVersion'),
	pageRoute('about'),
	pageRoute('contact'),
	pageRoute('privacy'),
	pageRoute('disclaimer'),
	pageRoute('terms'),
	{
		path: blogIndex.slug,
		name: 'id-blog',
		meta: {
			appname: 'WA GB',
			contentKey: 'blogIndex',
			title: blogIndex.seoTitle,
			keywords: blogIndex.keywords,
			description: blogIndex.description,
			link: [
				{
					rel: 'canonical',
					href: canonical(blogIndex.slug)
				}
			]
		},
		component: ContentPage
	},
	...blogs.map((blog) => blogRoute(blog))
]

const routes = constRoutesPc

export default function createRouter() {
	return new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			}
			return { x: 0, y: 0 }
		}
	})
}
